module.exports = __webpack_public_path__ + "static/tony-002-0c099562fb1727a9e45af9f2a20476ad.jpg";